import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { PlanoTrocaCodigoFormulas } from './plano-troca-codigo-formulas';
import { listarVariaveisObservacao } from './formula-contexto.util';

export { PlanoTrocaCodigoFormulas } from './plano-troca-codigo-formulas';

export function planejarTrocaCodigoFormulas(
    estados: FormulaItemStruct[],
    formulasAnteriores: FormulaCatalogoItemStruct[],
    formulasNovas: FormulaCatalogoItemStruct[],
    observacoesAtuais: Record<string, string | null | undefined>,
): PlanoTrocaCodigoFormulas {
    const codigosNovos = new Set(formulasNovas.map(formula => formula.chaveFormula));
    const estadosParaRestaurar = estados.filter(estado =>
        estado.tipo !== TipoFormulaEnum.ModeloPadrao
        && formulasAnteriores.some(formula => formula.chaveFormula === estado.chaveFormula)
        && !codigosNovos.has(estado.chaveFormula));
    const variaveisAnteriores = new Map(
        listarVariaveisObservacao(formulasAnteriores)
            .map(variavel => [variavel.chave, variavel] as const));
    const variaveisNovas = listarVariaveisObservacao(formulasNovas);
    const chavesNovas = new Set(variaveisNovas.map(variavel => variavel.chave));
    const pendentes = new Set<string>();
    const observacoes: Record<string, string> = {};

    Object.entries(observacoesAtuais).forEach(([campo, valor]) => {
        if (!valor) return;
        observacoes[campo] = valor.replace(/\{([^{}]+)\}/g, (token, chave: string) => {
            if (chavesNovas.has(chave)) return token;
            const variavelAnterior = variaveisAnteriores.get(chave);
            if (!variavelAnterior) return token;

            const gruposAnteriores = new Set(variavelAnterior.chavesGruposEquivalencia ?? []);
            const equivalentes = variaveisNovas
                .filter(variavel => (variavel.chavesGruposEquivalencia ?? [])
                    .some(chaveGrupo => gruposAnteriores.has(chaveGrupo)))
                .filter((variavel, indice, todas) =>
                    todas.findIndex(item => item.chave === variavel.chave) === indice);

            if (equivalentes.length === 1) return `{${equivalentes[0].chave}}`;

            pendentes.add(variavelAnterior.nome);
            return '{}';
        });
    });

    return {
        estadosParaRestaurar,
        variaveisPendentes: [...pendentes].sort(),
        observacoes,
    };
}
